import React from 'react';

import { SVGComponentProps } from './svg.types';

const DateDashedSVG = ({ size = '1em', wrapperClass, ...otherSvgProps }: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.1923 6.15898H15.3077V5.91722C15.3077 5.41012 14.8856 5 14.3654 5C13.8452 5 13.4231 5.41012 13.4231 5.91722V6.15898H9.65385V5.91722C9.65385 5.41012 9.23175 5 8.71154 5C8.19133 5 7.76923 5.41012 7.76923 5.91722V6.15898H5.88462C4.8442 6.15898 4 6.9807 4 7.99341V17.1656C4 18.1783 4.8442 19 5.88462 19H17.1923C18.2327 19 19.0769 18.1783 19.0769 17.1656V7.99341C19.0769 6.97996 18.2327 6.15898 17.1923 6.15898ZM17.4615 17.1656H5.88462V9H17.1923L17.4615 17.1656ZM7.5598 11.5001C7.5598 11.0858 7.89558 10.7501 8.3098 10.7501H13.6944C14.1086 10.7501 14.4444 11.0858 14.4444 11.5001C14.4444 11.9143 14.1086 12.2501 13.6944 12.2501H8.3098C7.89558 12.2501 7.5598 11.9143 7.5598 11.5001ZM8.3098 13.25C7.89558 13.25 7.5598 13.5858 7.5598 14C7.5598 14.4143 7.89558 14.75 8.3098 14.75H12.6175C13.0317 14.75 13.3675 14.4143 13.3675 14C13.3675 13.5858 13.0317 13.25 12.6175 13.25H8.3098Z"
          fill="#BCBEC2"
        />
        <circle cx="12" cy="12" r="12" stroke="gray" strokeWidth="1" strokeDasharray="3" />
      </svg>
    </span>
  );
};

export default DateDashedSVG;
